import { FC } from 'react';
import { ArrowIcon, SetUpProfileGirlIcon } from 'assets';
import { Button } from 'view/components';
import * as S from 'view/modals/OnboardingWizard/styled';

interface WelcomeStepProps {
  onNext: () => void;
}

const WelcomeStep: FC<WelcomeStepProps> = ({ onNext }) => {
  return (
    <S.WizardContent>
      <S.StepImage>
        <SetUpProfileGirlIcon />
      </S.StepImage>
      <S.StepHeader>
        <S.StepTitle>Welcome to Injobnito! Let&apos;s get started</S.StepTitle>
        <S.StepSubtitle
          style={{
            maxWidth: 250,
          }}
        >
          We just need a few details about you to provide relevant matches
        </S.StepSubtitle>
      </S.StepHeader>
      <S.WizardFooter>
        <Button
          variant="contained"
          text="Set up profile"
          onClick={onNext}
          style={{ width: '100%' }}
          endIcon={<ArrowIcon rotate="right" color="#FFFFFF" />}
        />
      </S.WizardFooter>
    </S.WizardContent>
  );
};

export default WelcomeStep;
